(function () {
  'use strict';

  angular
    .module('initiativeUpdateStatusControllers')
    .directive('ownerWithInitiatives', directive);

  directive.$inject = [];

  function directive() {
    return {
      scope: {
        ownerWithInitiatives: '=model',
        onToggleAllOwnerInitiatives: '&',
        onGoToInitiative: '&'
      },
      restrict: 'A',
      templateUrl: require('./ownerWithInitiatives.tpl.html'),
      controller: ['$scope', function ($scope) {

      }]
    }
  }
})();
